import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';

import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { PurchaseReport } from 'Pages/InnerPages/LapuAccounting/PurchaseReport';
import {
    Select as LAPUPARTY_SELECT,
    Purchase as LAPUPURCHASE_INSERT
} from 'Components/Api/LapuAccountingAPI';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { SelectOperatorPrepaidAndDTH as OPERATOR_SELECT } from 'Components/Api/OperatorsApi';
import { MaterialDatePickerField } from 'Components/Inputes/MaterialDatePickerField';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import {
    Container,
    Grid,
    Paper,
    Button,
    MenuItem,
    CircularProgress
} from '@material-ui/core';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    MESSAGE_CLOSE_AFTER,
    PLEASE_PROVIDE_VALID,
    PLEASE_SELECT_VALID
} from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';

const CustomContainer = HOCLoader(Container);

export const LapuPurchase = () => {
    const classes = commonStyle();

    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = React.useState(false);
    const [severity, setSeverity] = useState('success');
    const [operatorList, setOperatorList] = useState([]);
    const [lapuPartyList, setLapuPartyList] = useState([]);

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        if (loading) {
            setLoading(false);
            return;
        }

        var requestObj = JSON.stringify(values);
        setSubmitting(false);
        setIsError(false);
        setLoading(true);

        var response = await LAPUPURCHASE_INSERT(requestObj);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setSubmitting(true);
        setSeverity('success');
        setResponseMessage(response.data);
        setIsError(true);

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            return;
        }

        resetForm(FormObj);
        resetForm(FormData);
        setTimeout(() => {
            window.location.reload();
        }, MESSAGE_CLOSE_AFTER);
    };

    const FormValidationSchema = Yup.object({
        LapuNo: Yup.string().required(PLEASE_PROVIDE_VALID + 'lapu no'),
        OperatorID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + ' operator')
            .required(PLEASE_SELECT_VALID + 'operator'),
        LapuPartyMasterID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + ' lapu party')
            .required(PLEASE_SELECT_VALID + 'lapu party'),

        PurchaseDate: Yup.date()
            .nullable(PLEASE_SELECT_VALID + ' date')
            .required(PLEASE_SELECT_VALID + 'date')
            .max(new Date(), PLEASE_SELECT_VALID + ' date')
            .typeError(PLEASE_SELECT_VALID + ' date'),
        Amount: Yup.number().required(PLEASE_PROVIDE_VALID + 'amount')
    });
    var FormData = {
        Amount: 0,
        LapuPartyMasterID: 0,
        LapuNo: '',
        PurchaseDate: new Date(),
        OperatorID: 0
    };

    const [FormObj, setFormObj] = useState({
        Amount: 0,
        LapuPartyMasterID: 0,
        LapuNo: '',
        PurchaseDate: new Date(),
        OperatorID: 0
    });

    const selectLapuParty = async () => {
        const response = await LAPUPARTY_SELECT();

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        setLapuPartyList(data);
    };

    const selectOperators = async () => {
        const response = await OPERATOR_SELECT();

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        setOperatorList(data);
    };

    useEffect(() => {
        selectLapuParty();
        selectOperators();
    }, []);

    const LapuPartyItems = lapuPartyList.map(
        ({ LapuPartyMasterID, PartyName }) => (
            <MenuItem key={LapuPartyMasterID} value={LapuPartyMasterID}>
                {PartyName}
            </MenuItem>
        )
    );

    const OperatorItems = operatorList.map(({ OperatorID, OperatorName }) => (
        <MenuItem key={OperatorID} value={OperatorID}>
            {OperatorName}
        </MenuItem>
    ));

    const UploadForm = (formProps) => {
        return (
            <Form>
                <Grid item xs={12}>
                    <Paper className={classes.PaperStyle}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <MaterialDatePickerField
                                    name="PurchaseDate"
                                    label="Purchase Date"
                                    maxDate={new Date()}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <MaterialSelect
                                    name="OperatorID"
                                    label="Operator"
                                    title="Operator"
                                >
                                    <MenuItem key="0" value="0">
                                        Operator
                                    </MenuItem>
                                    {OperatorItems}
                                </MaterialSelect>
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <MaterialSelect
                                    name="LapuPartyMasterID"
                                    label="LapuParty"
                                    title="LapuParty"
                                >
                                    <MenuItem key="0" value="0">
                                        LapuParty
                                    </MenuItem>
                                    {LapuPartyItems}
                                </MaterialSelect>
                            </Grid>

                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <MaterialNumberField
                                    label="LapuNo"
                                    name="LapuNo"
                                    type="text"
                                    length={10}
                                    placeholder="LapuNo"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <MaterialNumberField
                                    label="Purchase Amount"
                                    name="Amount"
                                    type="text"
                                    length={6}
                                    placeholder="Purchase Amount"
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid className={classes.footerGrid}>
                    <Box className={classes.flexReverse}>
                        <div className={classes.SubmitWrapper}>
                            <Button
                                type="submit"
                                title="Purchase"
                                className={classes.CustomPrimaryButtonStyle}
                                disabled={loading}
                            >
                                Purchase
                            </Button>
                            {loading && (
                                <CircularProgress
                                    size={24}
                                    className={classes.buttonProgress}
                                />
                            )}
                        </div>
                        <Button
                            type="reset"
                            variant="contained"
                            color="secondary"
                            title="Reset"
                            className={classes.CustomDangerButtonStyle}
                        >
                            Reset
                        </Button>
                    </Box>
                </Grid>
            </Form>
        );
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={FormObj}
                validationSchema={FormValidationSchema}
                onSubmit={handleSubmit}
                resetForm={FormObj}
            >
                {UploadForm}
            </Formik>

            <PurchaseReport />
        </CustomContainer>
    );
};
